import type { SubAsset } from '@/common/sub-asset';

import { Card, CardContent } from '../../ui/card';
import { SubAssetItem } from '../sub-asset-list/SubAssetItem';

export type SubAssetTreeSelectorProps = {
	selectedId: string;
	onSelect: (id: string) => void;
	subAssets: SubAsset[];
};

export function SubAssetTreeSelector({ selectedId, onSelect, subAssets }: SubAssetTreeSelectorProps) {
	return (
		<Card className="bg-card p-2">
			<CardContent className="p-0 max-h-75 overflow-y-auto">
				<SubAssetItem
					subAsset={subAssets?.[0]}
					onSelect={onSelect}
					selectedId={selectedId}
					defaultExpanded
					viewOnlyMode
				/>
			</CardContent>
		</Card>
	);
}
